import {configure} from 'mobx'

// This looks dumb but it's the only way (?) to cast string as literal string
// https://basarat.gitbooks.io/typescript/docs/types/literal-types.html
const settings = {enforceActions: 'observed' as const}

export const confMobx = () => configure(settings)
